import React from "react";
import "./tc.css";
import Nav from "../nav.js";
import MetaData from "../MetaData.js";

export default function Shippingpolicy() {
  return (
    <>
      <MetaData title="Shipping Policy | GLOCRE Private Limited" />
      <Nav />
      {/* Terms & Conditions */}
      <body className="body-tc-glc">
        <section className="container">
          {/* Heading */}
          <div className="heading-tc-glc">
            <h1>Shipping Policy</h1>
            <h4>Effective Date: 26-02-2026</h4>
            <h4>Last Updated: 18-03-2026 </h4>
            <p>
              At Glocre Private Limited, we prioritize customer satisfaction by ensuring that
              every shipment is processed, handled, and delivered with care and
              efficiency. This Shipping Policy outlines the procedures, charges,
              and responsibilities related to the shipment of products purchased
              through our platform.
            </p>
          </div>

          {/* Contents */}
          <div className="">
            <div className="contents-tc-glc">
              <h6>1. Order Processing & Dispatch</h6>
              <p>
                Once your order is successfully placed, the product(s) will be
                processed and dispatched as per the availability and estimated
                delivery timelines mentioned on the product page.
              </p>
              <ul>
                <li>
                  <b>Delivery Timelines:</b> Orders are delivered within a
                  minimum of <b>1 day</b> and a maximum of <b>7 days</b> from
                  the date of dispatch, depending on the delivery location and
                  courier availability.
                </li>

                <li>
                  <b>Warehouse Handling:</b> All products are carefully
                  inspected and packaged at our warehouse before being handed
                  over to our trusted courier partners for delivery.
                </li>
                <li>
                  <b>Delivery Partners:</b> We partner with reliable third-party
                  logistics providers to ensure prompt and safe delivery to your
                  address.
                </li>
              </ul>
            </div>

            <div className="contents-tc-glc">
              <h6>2. Shipping Options & Charges</h6>
              <p>
                Shipping options and charges are calculated at checkout based on
                product weight, size, destination, and selected delivery method.
              </p>
              <ul>
                <li>
                  <b>Multiple Shipments:</b> In case your order contains items
                  that require special packaging or handling, they may be
                  shipped separately.
                </li>
                <li>
                  <b>Shipping Cost Optimization:</b> Customers can reduce
                  shipping costs by combining multiple items into a single order
                  instead of placing separate orders.
                </li>
              </ul>
            </div>

            <div className="contents-tc-glc">
              <h6>3. Undeliverable or Refused Shipments</h6>
              <p>
                If the customer refuses delivery, is unreachable, or declines to
                pay applicable duties/taxes:
              </p>
              <ul>
                <li>
                  <b>Return to Origin:</b> The shipment will be returned to our
                  warehouse.
                </li>
                <li>
                  <b>Refund Eligibility:</b> Refunds may be processed per our
                  return policy, excluding shipping charges, customs fees,
                  restocking fees, and any non-refundable charges.
                </li>
                <li>
                  <b>Non-returnable Situations:</b> If the shipment is not
                  returned or is non-returnable, no refund will be issued.
                </li>
              </ul>
            </div>

            <div className="contents-tc-glc">
              <h6>4. Prohibited & Restricted Items</h6>
              <p>
                GLOCRE complies with international trade regulations, but
                certain products may be prohibited or restricted for import into
                some countries.
              </p>
              <ul>
                <li>
                  <b>Customer Responsibility:</b> Customers must ensure that the
                  products they order comply with the import laws of their
                  country.
                </li>
                <li>
                  <b>No Guarantee:</b> GLOCRE makes no guarantees regarding the
                  import eligibility of any product into any country.
                </li>
                <li>
                  <b>Non-refundable Orders:</b> If customs reject or confiscate
                  restricted items, no refund will be provided.
                </li>
              </ul>
            </div>

            <div className="contents-tc-glc">
              <h6>5. Possible Delivery Delays</h6>
              <p>
                While we strive to deliver orders within the estimated
                timeframe, delays may occur due to:
              </p>
              <ul>
                <li>Bad weather</li>
                <li>Flight delays</li>
                <li>National holidays or festivals</li>
                <li>Customs clearance procedures</li>
                <li>Natural disasters</li>
                <li>Outbreaks or pandemics</li>
                <li>Other unforeseen circumstances</li>
              </ul>
            </div>

            <div className="contents-tc-glc">
              <h6>6. Shipment Tracking</h6>
              <p>
                Customers can track their shipments using the Order ID provided:
              </p>
              <ul>
                <li>
                  <b>Website:</b> Visit the "Track Order" section on our
                  website.
                </li>
              </ul>
            </div>

            <div className="contents-tc-glc">
              <h6>7. Need Assistance?</h6>
              <p>
                For any shipping-related queries or assistance, feel free to
                contact our customer support team at{" "}
                <b style={{ color: "#ffad63", fontSize: "20px" }}>
                  support@glocre.com
                </b>
                .
              </p>
            </div>
          </div>
        </section>
      </body>
    </>
  );
}
